import { useEffect, useMemo } from 'react';
import { fetchPlacements } from 'core/actions/ocapi';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectSlideMessageConfig,
  makeSelectSlideMessage, makeSelectSlideMessageIsLoaded, makeSelectSlideMessageIsLoading,
} from '../selectors';

export const useGetSlideMessage = ({ step }) => {
  const dispatch = useDispatch();
  const config = useSelector(selectSlideMessageConfig);

  const { api, shouldUseSlideMessage } = config;
  const params = api.getParams(step);
  const { offer_tag: namespace } = params;

  const options = {
    ...api.options,
    namespace,
  };

  const selectSlideMessageIsLoaded = useMemo(makeSelectSlideMessageIsLoaded, [namespace]);
  const selectSlideMessageIsLoading = useMemo(makeSelectSlideMessageIsLoading, [namespace]);
  const selectSlideMessage = useMemo(makeSelectSlideMessage, [namespace]);

  const isLoaded = useSelector(state => selectSlideMessageIsLoaded(state, namespace));
  const isLoading = useSelector(state => selectSlideMessageIsLoading(state, namespace));
  const data = useSelector(state => selectSlideMessage(state, namespace));

  useEffect(() => {
    if (!isLoaded && !isLoading && shouldUseSlideMessage) {
      dispatch(fetchPlacements(params, options));
    }
  }, [isLoaded, isLoading]);

  return {
    data,
    isLoaded,
    isLoading,
  };
};
